import { ApiService } from '@/api/services/core/ApiService';
import { TaxPayersQueryParams } from '@/api/services/types';
import { axiosInstance } from '@/api/axios';

export class AdminService extends ApiService {
  public getTaxpayersList(params: TaxPayersQueryParams) {
    return axiosInstance.get<any>('/taxPayers/withBalance', {
      params: { ...params },
    });
  }
}

